module.exports = __webpack_public_path__ + "fonts/Lyon Arabic Display Black.6c40cd0.otf";